import React from "react";
import { Outlet } from "react-router-dom";
import { ThemeProvider } from "../providers/theme-provider";

export const RootLayout: React.FC = () => {
    return (
        <ThemeProvider>
            <div className="h-screen w-screen overflow-hidden">
                <Outlet />
            </div>
        </ThemeProvider>
    );
};
